import { getBranchByCompanyId } from '@/services/branchs';
import { UserStore } from '@/store/user';
import { useSettingContext } from '@hooks/useSettingContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { PropsWithChildren, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AuthHOC = ({ children }: PropsWithChildren) => {
  const { user, getPermissions } = UserStore.getState();

  const navigate = useNavigate();
  const { getSettingCompany, getSettingBranch } = useSettingContext();
  const company = user?.companySelected;
  const queryClient = useQueryClient();
  const {error} = useQuery({
    queryKey: ['branchs'],
    queryFn: getBranchByCompanyId(company?.id ?? ''),
    enabled: !!company?.id,
  });
  const initialize = useCallback(async () => {
    try {
      await getSettingCompany({ navigate, queryClient }).catch(e => {});
      await getPermissions({ queryClient });
      await getSettingBranch({ navigate, queryClient });
    } catch (error) {
      console.error(error);
      navigate('/auth/login', { replace: true });
    }
  }, [user?.id]);

  useEffect(() => {
    if(user?.id) initialize();
  }, [user?.id]);
  return <>{children}</>;
};
